import _ from 'lodash';

import * as types from './types';
import { UpdateBidPriceDetailsEnum, BidPriceEnum } from 'Common/FieldEnum';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';
import { getGTINNumber, makeBidItem } from '../../helpers';

const INITIAL_STATE = {
  //get price details
  bidPriceDetailsData: null,
  loadingBidPriceDetails: false,
  bidPriceDetailsLoadingError: null,

  //control info api data
  selectedBidControlInfo: null,
  loadingControlInfo: false,
  controlInfoLoadingError: null,

  //save api data
  isSubmitting: false,
  submitted: false,
  submitError: null,

  //remove bid item
  deletedBidIds: [],

  //warehouse warning
  warehouseWarning: null,
  loadingWarehouseWarning: false,
  warehouseWarningLoadingError: null,
  originalBidPriceData: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    //get price details
    case types.BID_PRICE_DETAILS_LOADING:
      return {
        ...state,
        loadingBidPriceDetails: action.payload,
      };

    case types.BID_PRICE_DETAILS_DATA:
      const bidPriceDetailsData = _.cloneDeep(action.payload);
      const BidPriceDetailsCopy = bidPriceDetailsData.BidPriceDetails.map(
        bidItem => {
          bidItem = makeBidItem(bidItem);
          bidItem[BidPriceEnum.Value] = (+bidItem[BidPriceEnum.Value]).toFixed(
            4
          );
          bidItem[UpdateBidPriceDetailsEnum.QtyPerUnitTextEnabled] = true;
          return bidItem;
        }
      );
      bidPriceDetailsData.BidPriceDetails = BidPriceDetailsCopy;
      const originalBidPriceData = _.cloneDeep(BidPriceDetailsCopy);
      return {
        ...state,
        bidPriceDetailsData,
        originalBidPriceData,
      };

    case types.BID_PRICE_DETAILS_LOADING_ERROR:
      const bidPriceDetailsLoadingResponse = action.payload.response;
      if (
        _.has(bidPriceDetailsLoadingResponse, 'data.Errors') &&
        bidPriceDetailsLoadingResponse.data.Errors.length
      ) {
        return {
          ...state,
          bidPriceDetailsLoadingError:
            bidPriceDetailsLoadingResponse.data.Errors,
        };
      }
      return {
        ...state,
        bidPriceDetailsLoadingError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while fetching bid details. Please try again',
        },
      };

    case types.BID_PRICE_ERROR:
      return {
        ...state,
        bidPriceDetailsLoadingError: null,
        controlInfoLoadingError: null,
        submitError: null,
        warehouseWarningLoadingError: null,
      };

    case types.SUBMITTING_BID_PRICE_DETAILS:
      return {
        ...state,
        isSubmitting: action.payload,
      };

    case types.BID_PRICE_DETAIL_SUBMIT:
      return {
        ...state,
        submitted: true,
      };

    case types.SUBMITTING_BID_PRICE_DETAILS_ERROR:
      const bidPriceDetailsErrorResponse = action.payload.response;
      if (
        _.has(bidPriceDetailsErrorResponse, 'data.Errors') &&
        bidPriceDetailsErrorResponse.data.Errors.length
      ) {
        return {
          ...state,
          submitError: bidPriceDetailsErrorResponse.data.Errors,
        };
      }
      return {
        ...state,
        submitError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while updating bid price details. Please try again',
        },
      };

    //control info
    case types.BID_PRICE_CONTROL_INFO_LOADING:
      return {
        ...state,
        loadingControlInfo: action.payload,
      };

    case types.BID_PRICE_CONTROL_INFO_DATA:
      const bidPriceDetailsData1 = _.cloneDeep(state.bidPriceDetailsData);
      const BidPriceDetailsCopy1 = bidPriceDetailsData1.BidPriceDetails.map(
        bidItem => {
          if (
            action.payload.ItemId === bidItem.ItemId &&
            action.payload.BidId === bidItem.BidId
          ) {
            bidItem.QtyPerUnitTextEnabled =
              action.payload.QtyPerUnitTextEnabled;
            bidItem.PrimaryPriceTextEnabled =
              action.payload.PrimaryPriceTextEnabled;
            bidItem.SecUnitComboEnabled = action.payload.SecUnitComboEnabled;
            bidItem.UnitComboEnabled = action.payload.UnitComboEnabled;
          }
          return bidItem;
        }
      );
      bidPriceDetailsData1.BidPriceDetails = BidPriceDetailsCopy1;
      return {
        ...state,
        selectedBidControlInfo: action.payload,
        bidPriceDetailsData: bidPriceDetailsData1,
      };

    case types.BID_PRICE_CONTROL_INFO_LOADING_ERROR:
      const bidControlErrorResponse = action.payload.response;
      if (
        _.has(bidControlErrorResponse, 'data.Errors') &&
        bidControlErrorResponse.data.Errors.length
      ) {
        return {
          ...state,
          controlInfoLoadingError: bidControlErrorResponse.data.Errors,
        };
      }
      return {
        ...state,
        controlInfoLoadingError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while fetching control information for selected row. Please try again',
        },
      };

    case types.CLEAR_BID_PRICE_CONTROL_INFO:
      return {
        ...state,
        selectedBidControlInfo: null,
        loadingControlInfo: false,
        controlInfoLoadingError: null,
      };

    //handle removing items
    case types.BID_PRICE_REMOVE_ITEM:
      const data = _.cloneDeep(state.bidPriceDetailsData.BidPriceDetails);
      const deletedBidIds = _.cloneDeep(state.deletedBidIds);
      action.payload.bidItem.BidId &&
        deletedBidIds.push(action.payload.bidItem.BidId);
      data.splice(action.payload.index, 1);
      const bidData = {
        ...state.bidPriceDetailsData,
        BidPriceDetails: data,
      };
      return {
        ...state,
        bidPriceDetailsData: bidData,
        deletedBidIds,
      };

    case types.BID_PRICE_UPDATE_GRID:
      const bidPriceDetailsData2 = _.cloneDeep(state.bidPriceDetailsData);
      const gridBidItem = action.payload.input;

      if (gridBidItem.fieldName === BidPriceEnum.VendorId) {
        _.some(bidPriceDetailsData2.Vendors, vendor => {
          if (vendor.Id === gridBidItem.newValue) {
            bidPriceDetailsData2.BidPriceDetails[gridBidItem.selectedIndex][
              BidPriceEnum.VendorName
            ] = vendor.Description;
            bidPriceDetailsData2.BidPriceDetails[gridBidItem.selectedIndex][
              BidPriceEnum.VendorId
            ] = vendor.Id;
            return true;
          }
        });

        bidPriceDetailsData2.BidPriceDetails[gridBidItem.selectedIndex][
          BidPriceEnum.GTINNumber
        ] = getGTINNumber(bidPriceDetailsData2.BidPriceDetails, gridBidItem);
      } else {
        //set prevValue, if user clicks, no for warehouse warning pop-up
        if (action.payload.updateToPrevValue) {
          bidPriceDetailsData2.BidPriceDetails[gridBidItem.selectedIndex][
            gridBidItem.fieldName
          ] = action.payload.input.prevValue;
        } else {
          bidPriceDetailsData2.BidPriceDetails[gridBidItem.selectedIndex][
            gridBidItem.fieldName
          ] = gridBidItem.newValue;
        }
      }
      bidPriceDetailsData2.BidPriceDetails[
        gridBidItem.selectedIndex
      ].modified = true;
      return {
        ...state,
        bidPriceDetailsData: bidPriceDetailsData2,
      };

    //add new bid item
    case types.BID_PRICE_ADD_NEW_ITEM:
      const BidPriceDetails = _.cloneDeep(
        state.bidPriceDetailsData.BidPriceDetails
      );
      BidPriceDetails.unshift(action.payload);
      const bidObj = {
        ...state.bidPriceDetailsData,
        BidPriceDetails,
      };
      return {
        ...state,
        bidPriceDetailsData: bidObj,
      };
    //warehouse warning
    case types.BID_PRICE_WAREHOUSE_WARNING_LOADING:
      return {
        ...state,
        loadingWarehouseWarning: action.payload,
      };

    case types.BID_PRICE_WAREHOUSE_WARNING_DATA:
      return {
        ...state,
        warehouseWarning: action.payload,
      };

    case types.BID_PRICE_WAREHOUSE_WARNING_LOADING_ERROR:
      const warehouseWarningLoadingResponse = action.payload.response;
      if (
        _.has(warehouseWarningLoadingResponse, 'data.Errors') &&
        warehouseWarningLoadingResponse.data.Errors.length
      ) {
        return {
          ...state,
          warehouseWarningLoadingError:
            warehouseWarningLoadingResponse.data.Errors,
        };
      }
      return {
        ...state,
        warehouseWarningLoadingError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while fetching warehouse warning. Please try again',
        },
      };

    case types.RESET_WAREHOUSE_WARNING:
      return {
        ...state,
        warehouseWarning: null,
      };

    case types.RESET_BID_PRICE_DATA:
      const bidPriceDetailsDataCopy = _.cloneDeep(state.bidPriceDetailsData);
      bidPriceDetailsDataCopy.BidPriceDetails = action.payload;
      return {
        ...state,
        bidPriceDetailsData: bidPriceDetailsDataCopy,
      };

    case types.RESET_DELETE_IDS:
      return {
        ...state,
        deletedBidIds: [],
      };

    case types.CLEAR_BID_PRICE_DATA:
      let bidPriceDetailsDataCopy1 = _.cloneDeep(state.bidPriceDetailsData);
      const bidPriceData = {
        ...bidPriceDetailsDataCopy1,
        BidPriceDetails: [],
      };
      return {
        ...state,
        bidPriceDetailsData: bidPriceData,
      };

    case types.ADD_BID_FOR_NEW_ITEM:
      let bidPriceDetailsDataCopy2 = _.cloneDeep(state.bidPriceDetailsData);
      const bidPriceData2 = {
        ...bidPriceDetailsDataCopy2,
        BidPriceDetails: [action.payload],
      };
      return {
        ...state,
        bidPriceDetailsData: bidPriceData2,
        originalBidPriceData: _.cloneDeep([action.payload]),
      };

    case types.BID_PRICE_ADD_PURCHASE_UNIT:
      const unit = action.payload && action.payload.trim().toUpperCase();
      const bidPriceDetailsCopy = { ...state.bidPriceDetailsData };
      if (unit) {
        const existingUnits = [
          ...bidPriceDetailsCopy[UpdateBidPriceDetailsEnum.Units],
        ];
        existingUnits &&
          Array.isArray(existingUnits) &&
          existingUnits.indexOf(unit) === -1 &&
          existingUnits.push(unit);
        bidPriceDetailsCopy[UpdateBidPriceDetailsEnum.Units] = existingUnits;
      }
      return {
        ...state,
        bidPriceDetailsData: bidPriceDetailsCopy,
      };
    case types.BID_PRICE_ADD_SEC_UNIT:
      const secUnit = action.payload && action.payload.trim().toUpperCase();
      const bidPriceDetailsCopyForSecUnit = { ...state.bidPriceDetailsData };
      if (secUnit) {
        const existingSecUnits = [
          ...bidPriceDetailsCopyForSecUnit[
            UpdateBidPriceDetailsEnum.SecondaryUnits
          ],
        ];
        existingSecUnits &&
          Array.isArray(existingSecUnits) &&
          existingSecUnits.indexOf(secUnit) === -1 &&
          existingSecUnits.push(secUnit);
        bidPriceDetailsCopyForSecUnit[
          UpdateBidPriceDetailsEnum.SecondaryUnits
        ] = existingSecUnits;
      }
      return {
        ...state,
        bidPriceDetailsData: bidPriceDetailsCopyForSecUnit,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/inventory/itemmaintenance/state/updateBidPriceDetails/reducer.js